export default {
  state: {
    isOpenModalUserPhotos: false,
    isOpenModalStore: false,
    isOpenModalImage: false,
    isOpenModalSeeMoreReviews: false,
    storeId: [],
    userPhotos: '',
    totalUserPhoto: '',
    initialIndexSlide: 0,
    totalUserReviews: 0,
  },
  mutations: {
    mergeUserPhotos(state, data) {
      const mergeUserPhotos = state.userPhotos.concat(data);
      state.userPhotos = mergeUserPhotos;
    },
    setInitialIndexSlide(state, value) {
      state.initialIndexSlide = value;
    },
    setModalUserPhotos(state, value) {
      state.isOpenModalUserPhotos = value;
    },
    setModalStore(state, value) {
      state.isOpenModalStore = value.show ? value.show : false;
      state.storeId = value.data ? value.data : [];
    },
    setModalImage(state, value) {
      state.isOpenModalImage = value;
    },
    setUserPhotos(state, data) {
      state.userPhotos = data;
    },
    setTotalUserPhoto(state, total) {
      state.totalUserPhoto = total;
    },
    setModalSeeMoreReviews(state, value) {
      state.isOpenModalSeeMoreReviews = value;
    },
  },
  actions: {
    getUserReviewImages({ commit }, { params, product_id }) {
      return this._vm.$MS_REVIEW_API_URL.get(`/review-images/${product_id}/product`, {
        params: params,
      });
    },
  },
  getters: {},
};
